import { useActiveTripLeg, useVfCloseModal } from "../store/model-misc";
import { useColDefs } from "./dead-opps-table-coldefs";
import AgTable from "./AgTable";
import React from "react";
import _ from "lodash";
import {
  useIsDeadFlopptions,
  useIsReportActionFormOpen,
} from "./reporting-actions/modal-or-drawer";
import { Dialog } from "@blueprintjs/core";
import { useStoreState } from "../hooks/ep";

export function DeadFlopptionsModalWrapper(props) {
  return useIsDeadFlopptionsTableReady() && <DeadFlopptionsDialog {...props} />;
}

function useActiveTripLegDeadFlopptionsRows() {
  const activeTripLeg = useActiveTripLeg();
  const { TripId, leg_i } = activeTripLeg || { TripId: null, leg_i: null };
  return useStoreState(
    (s) => s.dead_flopptions.rowsByTripLegId({ TripId, leg_i }),
    [TripId, leg_i]
  );
}

export function useIsDeadFlopptionsTableReady() {
  const isDeadFlopptions = useIsDeadFlopptions();
  const dead_flopptionsRows = useActiveTripLegDeadFlopptionsRows();
  const isReady =
    isDeadFlopptions && !!(dead_flopptionsRows && _.size(dead_flopptionsRows));
  return isReady;
}

export function useDeadFlopptionsTitle() {
  const { TripId, leg_i } = useActiveTripLeg();
  const legName = leg_i && ["Inb", "Ret"][leg_i - 1];
  return (
    <span>
      Flight Options for Trip Leg Opportunity:&nbsp;
      <span
        css={`
          font-weight: bolder;
        `}
      >
        {TripId} {legName ? `(${legName})` : ""}
      </span>
    </span>
  );
}

export function DeadFlopptionsDialog() {
  const closeModal = useVfCloseModal();
  const drawerOpen = useIsReportActionFormOpen();

  return (
    <div
      css={`
        .bp3-dialog-container {
          width: ${drawerOpen ? "calc(100vw - 500px)" : "100vw"};
        }
      `}
    >
      <Dialog
        isOpen={true}
        onClose={closeModal}
        canEscapeKeyClose={false}
        title={useDeadFlopptionsTitle()}
        usePortal={false}
        css={`
          width: 95%;
        `}
      >
        <div
          css={`
            height: 58vh;
            padding: 24px;
            width: 100%;
          `}
        >
          <div
            css={`
              width: 100%;
            `}
          >
            <DeadFlopptionsTable height={"50vh"} />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export function DeadFlopptionsTable({ height }) {
  const dead_flopptionsRows = useActiveTripLegDeadFlopptionsRows();
  const colDefs = useColDefs("dead_flopptions");
  return (
    <AgTable
      tableName="dead_flopptions"
      rowData={dead_flopptionsRows}
      columnDefs={colDefs}
      height={height}
    />
  );
}
